function Select({ children, id, label, value, onChange }) {
    return (
        <div class="form-floating mb-2">
            <select class="form-select" id={id} name={id} value={value} onChange={onChange}>
                {children}
            </select>
            <label class="form-label" for={id}>{label}</label>
        </div>
    )
}

export default Select;